export default "__VITE_ASSET__BdTLOH3Q__"